var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-img',_vm._b({staticClass:"audiicon",style:(_vm.dark ? 'filter: invert(100%)' : ''),attrs:{"contain":"","src":`/audi-static/${_vm.icon}-${_vm.large ? 'large' : 'small'}.svg`,"max-width":_vm.size}},'v-img',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }